import { Layout, Typography } from "antd";
import { AuthForm } from "features/auth";
import { useTranslation } from "react-i18next";
import { toggleApiContext } from "shared/api";
import { message } from "shared/lib/antd-global";
import { useMultiClick } from "shared/lib/hooks";
import { AppLogo } from "shared/ui/app-logo";
import { AuthHeader } from "widgets/headers";

export const LoginPage = () => {
  const { t } = useTranslation();

  const handleSecretClick = useMultiClick(() => {
    const next = toggleApiContext();
    message.success(`API: ${next}`);
  });

  return (
    <Layout>
      <AuthHeader />
      <Layout.Content
        style={{
          paddingTop: "6vh",
        }}
        className="auth-layout-content"
      >
        <AppLogo
          style={{
            margin: 32,
          }}
          onClick={handleSecretClick}
        />
        <AuthForm />
        <Typography.Text style={{ marginTop: 16, display: "block" }}>
          {t("auth.agree_to_terms")}{" "}
          <a
            href="https://akjet.kz/assets/user_agreement.pdf?v=1"
            target="_blank"
            rel="noreferrer"
          >
            {t("auth.user_agreement")}
          </a>
        </Typography.Text>
      </Layout.Content>
    </Layout>
  );
};
